import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage';
import {rbacActions} from "../../../config/rbac/actions.ts";
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {PermissionsFailureGuard} from "../../../components/PermissionsFailureGuard.tsx";
import {CookiePreferencesPage} from "./pages/CookiePreferencesPage.tsx";
import {DeleteAccountPage} from "./pages/DeleteAccountPage.tsx";

export const AccountsLayout = () => {
    const {allowedActions} = useVerifiedPermissions()

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <div>

                        <IndexPage/>
                    </div>
                }
            />
            <Route
                path='add'
                element={
                    // Interim until FNP-1749
                    <PermissionsFailureGuard>{allowedActions.includes('CreateAccount') ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/accounts'/>
                    )}</PermissionsFailureGuard>
                }
            />
            <Route
                path=':id'
                element={
                    // Interim until FNP-1749
                    <PermissionsFailureGuard>{allowedActions.includes('GetAccount') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/accounts'/>
                    )}</PermissionsFailureGuard>
                }
            />

            <Route
                path="/cookie-preferences"
                element={
                    // Interim until FNP-1749
                    <PermissionsFailureGuard>{allowedActions.includes(rbacActions.UpdateUserAccount) ? (
                        <CookiePreferencesPage/>
                    ) : (
                        <Navigate to='/'/>
                    )}</PermissionsFailureGuard>
                }/>

            <Route
                path="/delete-account"
                element={
                    // Interim until FNP-1749
                    <PermissionsFailureGuard>{allowedActions.includes(rbacActions.DeleteUserAccount) ? (
                        <DeleteAccountPage/>
                    ) : (
                        <Navigate to='/'/>
                    )}</PermissionsFailureGuard>
                }/>

            {/* FNP-117: redirect the FNP-122-era route so any existing bookmarks
                still resolve to the real Delete Account page. */}
            <Route
                path="/suspend-account"
                element={<Navigate to='/account/delete-account' replace/>}
            />

        </Routes>
    );
};
